export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<path
			d="M2 5.3125C2 4.45312 2.66406 3.75 3.52344 3.75H20.4375C21.2969 3.75 22 4.45312 22 5.3125C22 5.66406 21.8438 6.01562 21.6094 6.28906L14.5 14.9219V19.9609C14.5 20.6641 13.875 21.25 13.1719 21.25C12.8594 21.25 12.5859 21.1719 12.3516 20.9766L9.96875 19.1406C9.65625 18.9062 9.46094 18.5547 9.46094 18.1641V14.9219L2.35156 6.28906C2.11719 6.01562 2 5.66406 2 5.3125ZM3.52344 5C3.36719 5 3.25 5.15625 3.25 5.3125C3.25 5.39062 3.25 5.42969 3.28906 5.50781L10.5938 14.2969C10.6719 14.4141 10.75 14.5703 10.75 14.6875V18.1641L13.1328 20C13.1328 20 13.1328 20 13.1719 20C13.2109 20 13.25 20 13.25 19.9609V14.6875C13.25 14.5703 13.2891 14.4141 13.3672 14.2969L20.6719 5.50781C20.7109 5.42969 20.75 5.39062 20.75 5.3125C20.75 5.15625 20.5938 5 20.4375 5H3.52344Z"
			fill="currentColor"
		/>
	</svg>
);
